// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../css-global/colors.scss\"","_paleYellow":"#fff1d2","root":"AlertBanner-module--root--zPFB_","alertImage":"AlertBanner-module--alertImage--3E76H"};